var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "form-group m-form__group row" }, [
      _c(
        "div",
        {
          class: [
            { "has-danger": _vm.errors.has("identification_number") },
            "col-lg-3"
          ]
        },
        [
          _c("label", { attrs: { for: "identification_number" } }, [
            _vm._v(
              _vm._s(
                _vm._f("capitalize")(
                  _vm._f("translate")("identification_number")
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.identification_number,
                expression: "identification_number"
              },
              {
                name: "validate",
                rawName: "v-validate",
                value:
                  _vm.report_type === 7 || _vm.report_type === 14
                    ? "required|numeric|min:4|max:12"
                    : "numeric|min:4|max:12",
                expression:
                  "report_type === 7 || report_type === 14 ? 'required|numeric|min:4|max:12' : 'numeric|min:4|max:12' "
              }
            ],
            staticClass: "form-control form-control-danger m-input",
            attrs: { type: "text", name: "identification_number" },
            domProps: { value: _vm.identification_number },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.identification_number = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("identification_number"),
                  expression: "errors.has('identification_number')"
                }
              ],
              staticClass: "m-form__help m--font-danger"
            },
            [
              _vm._v(
                " " + _vm._s(_vm.errors.first("identification_number")) + " "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: [{ "has-danger": _vm.errors.has("start_date") }, "col-lg-3"] },
        [
          _c("label", { attrs: { for: "start_date" } }, [
            _vm._v(
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("start_date")))
            )
          ]),
          _vm._v(" "),
          _c("s-date-time-picker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value:
                  _vm.report_type === 11 || _vm.report_type === 12
                    ? ""
                    : "required|validateDate",
                expression:
                  "report_type === 11  || report_type === 12 ? '' : 'required|validateDate'"
              }
            ],
            attrs: {
              id: "start_date",
              name: "start_date",
              options: _vm.config.start,
              placeholder: "AAAA-MM-DD"
            },
            on: {
              empty: function($event) {
                _vm.start_date = $event
              }
            },
            model: {
              value: _vm.start_date,
              callback: function($$v) {
                _vm.start_date = $$v
              },
              expression: "start_date"
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("start_date"),
                  expression: "errors.has('start_date')"
                }
              ],
              staticClass: "m-form__help m--font-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("start_date")) + " ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: [{ "has-danger": _vm.errors.has("end_date") }, "col-lg-3"] },
        [
          _c("label", { attrs: { for: "end_date" } }, [
            _vm._v(
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("end_date")))
            )
          ]),
          _vm._v(" "),
          _c("s-date-time-picker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value:
                  _vm.report_type === 11 || _vm.report_type === 12
                    ? ""
                    : "required|validateDate",
                expression:
                  "report_type === 11  || report_type === 12 ? '' : 'required|validateDate'"
              }
            ],
            attrs: {
              id: "end_date",
              name: "end_date",
              options: _vm.config.end,
              placeholder: "AAAA-MM-DD"
            },
            on: {
              empty: function($event) {
                _vm.end_date = $event
              }
            },
            model: {
              value: _vm.end_date,
              callback: function($$v) {
                _vm.end_date = $$v
              },
              expression: "end_date"
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("end_date"),
                  expression: "errors.has('end_date')"
                }
              ],
              staticClass: "m-form__help m--font-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("end_date")) + " ")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group m-form__group row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12", staticStyle: { "text-align": "right" } },
        [
          _c("label", { attrs: { for: "" } }, [_vm._v(" ")]),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-success m-btn m-btn--icon",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.generateReport()
                }
              }
            },
            [
              _c("span", [
                _c("i", { staticClass: "la la-archive" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm._f("capitalize")(
                        _vm._f("translate")("generate_report")
                      )
                    )
                  )
                ])
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32d62ed9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32d62ed9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/reports/forms/ForcedAccessForm.vue
// module id = 537
// module chunks = 0 1 4 43